export const SET_LABELLING_FLOW_DATA = 'SET_LABELLING_FLOW_DATA';
export const SET_TOOL_CONTEXT_MENU_DATA = 'SET_TOOL_CONTEXT_MENU_DATA';
export const RESET_LABELLING_AND_CONTEXT_MENU =
  'RESET_LABELLING_AND_CONTEXT_MENU';
export const SET_IMAGE_CONTEXT_DATA = 'SET_IMAGE_CONTEXT_DATA';
export const RESET_IMAGE_CONTEXT_DATA = 'RESET_IMAGE_CONTEXT_DATA';
export const SET_HEATMAP_CONTEXT_DATA = 'SET_HEATMAP_BUTTONS_DATA';
